export const EDIT = 'WIDGET_EDITOR.EDIT';
export const OPEN = 'WIDGET_EDITOR.OPEN';
export const CLOSE = 'WIDGET_EDITOR.CLOSE';


// WEBPACK FOOTER //
// ./src/constants/WidgetEditor.ts